import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { USER } from 'src/app/core/user.service';
import { BaseHttpClient } from 'src/app/shared/flight-log-api/bases/base-client.service';
import { BaseEntity } from 'src/store/base/base.model';
import { dutyLogCompanyBlacklist, UserViewModel } from 'src/view-models/user-view-model';
import { AutcompleteComponentBase } from '../autocomplete-helper/autocomplete-helper.component';

@Component({
  selector: 'fl-base-autocomplete-v2',
  template: ` <fl-autocomplete-helper [config]="helperConfig"></fl-autocomplete-helper> `,
  styleUrls: ['./base-autocomplete-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: BaseAutocompleteV2Component,
      multi: true,
    },
  ],
})
export class BaseAutocompleteV2Component extends AutcompleteComponentBase<BaseEntity, string> {
  public placeholder = 'Base';
  @Input()
  public disableGoldenHourBases = false;
  @Output()
  public optionSelected = new EventEmitter<BaseEntity>();
  public selectControlValue = (option: BaseEntity) => {
    this.optionSelected.emit(option);
    return option.id;
  };
  public optionDisplayFn(option: BaseEntity) {
    if (this.disableFn(option)) {
      return `${option.name} (GoldenHour)`;
    }
    return option.name;
  }
  public getSingleOption = (id: string) =>
    this._bases.getById(id).pipe(catchError((err, caught) => of(undefined)));
  public getManyOptions = (userInput: string) =>
    this._bases
      .getAll({
        companyId: this._user.companycode,
        searchTerm: userInput,
      })
      .pipe(catchError((e, c) => of([])));
  public disableFn(option: BaseEntity) {
    if (this.disableGoldenHourBases) {
      return dutyLogCompanyBlacklist.includes(option.companyId) && !option.enableFlightLogDutyLog;
    }
    return false;
  }

  constructor(
    @Inject(USER) private readonly _user: UserViewModel,
    private readonly _bases: BaseHttpClient,
  ) {
    super();
  }
}
